export interface StoreLocatorTextResourcesConfig {
  resources?: object;
}

export interface StoreLocatorRequestConfig {
  request?: object;
}

export interface StoreLocatorInitConfig {
  data?: object;
}

export const TextResources: StoreLocatorTextResourcesConfig = {};

export const RequestData: StoreLocatorRequestConfig = {};

export const ConfigData: StoreLocatorInitConfig = {};
